import React from 'react'
import { useNavigate } from 'react-router-dom';
import ButtonComponent from '../../components/ButtonComponent';

const RefundPolicy = () => {
    const navigate = useNavigate();
    const handleBackToPolicyPage = () => {
        navigate('/documents');
    }
    return (
        <>
            <div className="container mt-5 privacy-policy"><ButtonComponent title='Back to Policy Page' backgroundColor=' #590B21' onClick={handleBackToPolicyPage} /></div>
            <div className="container mt-2 mb-5 py-4 privacy-policy">
                <h3 className='fw-bold'>Refund & Cancellation Policy</h3>
                <h6 className='fw-bold'>Curry King (Private) Limited</h6>
                <p> Version 1.12 | Last Updated: 6th May 2025</p>
                <p>
                    At <strong>Curry King (Private) Limited</strong>, we take great pride in offering high-quality Sri Lankan rice and curry meals prepared under stringent hygiene standards. As a food service provider dealing with perishable goods, our refund and cancellation policy adheres strictly to food safety regulations and responsible business practices.
                </p>
                <hr />
                <h5 className='fw-bold'>1. Finality of Sale</h5>
                <ul>
                    <li>
                        <strong>All sales are deemed final and non-refundable</strong>, in accordance with <strong>food safety best practices</strong> and applicable <strong>regulatory standards.</strong>
                    </li>
                    <li>
                        Once a product has been <strong>sold, collected, or delivered, refunds, returns, or replacements will not be issued</strong>under normal circumstances.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>2. Exceptional Cases</h5>
                <ul>
                    <li>
                        In <strong>exceptional instances</strong>, if a <strong>legitimate complaint</strong> is raised <strong>within a reasonable time</strong> and is deemed <strong>fair and just</strong> by Curry King's management, a <strong>refund or replacement</strong> may be granted.
                    </li>
                    <li>
                        The decision to offer a refund or replacement is made <strong>sentirely at the sole discretion </strong>of Curry King, and each case will be evaluated <strong>individually.</strong>
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>3. Order Cancellation Process</h5>
                <h6 className='fw-bold'>3.1 Eligible Cancellations</h6>
                <ul>
                    <li>
                        Orders may be <strong>cancelled without penalty</strong> if the cancellation request is made <strong>at least 30 minutes before the scheduled dispatch</strong> from the central kitchen or cart allocation.
                    </li>
                    <li>
                        Cancellations made <strong>after dispatch</strong> or within <strong>30 minutes of expected delivery or pickup time</strong> will <strong>not be eligible for a refund</strong>.
                    </li>
                </ul>
                <h6 className='fw-bold'>3.2 How to Cancel</h6>
                <p>Customers may cancel an order through the following channels:</p>
                <ul>
                    <li>
                        Use the <strong>“Cancel Order”</strong> feature on the Curry King mobile app or website
                    </li>
                    <li>
                        Contact our customer care team via:
                        <ul>
                            <li>📞 +94 11 444 1300</li>
                            <li>📲 WhatsApp (via order confirmation link)</li>
                            <li>📧 support@curryking.lk</li>
                        </ul>
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>4. Claims Submission Process</h5>
                <p>To request a refund or replacement in exceptional cases:</p>
                <ol>
                    <li>
                        Report the issue within <strong>1 hour of receiving the order</strong>
                    </li>
                    <li>
                        Submit a formal complaint through one of our <strong>official communication channels</strong>.
                    </li>
                    <li>
                        Provide <strong>clear supporting evidence,</strong> such as:
                        <ul>
                            <li>Photographs of the issue</li>
                            <li>Order reference number</li>
                            <li>Description of the discrepancy</li>
                        </ul>
                    </li>
                </ol>
                <p>Only complaints lodged through <strong>verified channels</strong> will be considered for evaluation.</p>
                <hr />
                <h5 className='fw-bold'>5. Refund Process (If Approved)</h5>
                <ul>
                    <li>
                        If a refund is approved:
                        <ul>
                            <li>
                                It will be processed within <strong>5-7 business days</strong>.
                            </li>
                            <li>
                                The refund will be made via the <strong>original method of payment</strong>
                            </li>
                            <li>
                                In the case of <strong>cash payments</strong>, refunds may be issued via <strong>bank transfer</strong> or <strong>credit note</strong> , as determined by Curry King.
                            </li>
                        </ul>
                    </li>
                    <li>
                        Refunds will reflect the <strong>net amount paid</strong>, excluding any promotional discounts (e.g., Credit Card offers).
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>6. Governing Law</h5>
                <p>This Refund & Cancellation Policy is governed by and construed in accordance with the laws of <strong>Sri Lanka.</strong> Curry King (Private) Limited reserves the right to update or modify this policy at any time without prior notice.</p>
            </div>
        </>
    )
}

export default RefundPolicy;